import { render } from "./DriversItem.vue?vue&type=template&id=d61d52cc"
import script from "./DriversItem.vue?vue&type=script&lang=js"
export * from "./DriversItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__